import React, { createContext, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useGetAdmissionBoardCommitteeList } from '../../app/customHooks/useGetAdmissionBoardCommitteeList';
import { useGetBoardCommitteeList } from '../../app/customHooks/useGetBoardCommitteeList';
import { useGetTaskListDetailOfMemberById } from '../../app/customHooks/useGetTaskListDetailOfMemberById';

const MembershipTaskListContext = createContext();

export default MembershipTaskListContext;

export const MembershipTaskListContextProvider = ({ children }) => {
    const [isAdmissionBoardSubmittedByAdmin, setIsAdmissionBoardSubmittedByAdmin] = useState(false);
    const [isBoardCommitteeSubmittedByAdmin, setIsBoardCommitteeSubmittedByAdmin] = useState(false);
    const {
        fetchAdmissionBoardCommitteeList,
        admissionBoardCommitteeListData,
        isAdmissionBoardCommitteeListLoading,
        isAdmissionBoardCommitteeListSuccess,
        isAdmissionBoardCommitteeListError,
        admissionBoardCommitteeListError
    } = useGetAdmissionBoardCommitteeList();
    const {
        fetchBoardCommitteeList,
        boardCommitteeListData,
        isBoardCommitteeListLoading,
        isBoardCommitteeListSuccess,
        isBoardCommitteeListError,
        boardCommitteeListError,
    } = useGetBoardCommitteeList();

    const {
        fetchTaskListDetails,
        taskListDetailsData,
        isTaskListDetailsLoading,
        isTaskListDetailsSuccess,
        isTaskListDetailsError,
        TaskListDetailsError,
    } = useGetTaskListDetailOfMemberById();

    return (
        <MembershipTaskListContext.Provider value={{
            isAdmissionBoardSubmittedByAdmin, setIsAdmissionBoardSubmittedByAdmin,
            isBoardCommitteeSubmittedByAdmin, setIsBoardCommitteeSubmittedByAdmin,
            admissionBoardCommitteeListData, fetchAdmissionBoardCommitteeList, isAdmissionBoardCommitteeListLoading,
            boardCommitteeListData, fetchBoardCommitteeList, isBoardCommitteeListLoading,
            taskListDetailsData, fetchTaskListDetails,
        }}>
            {children}
        </MembershipTaskListContext.Provider>
    )
}


